<template>
  <TagsInputRoot
    :model-value="tags"
    :disabled="isDisabled"
    @update:model-value="updateTags"
    :class="[
      context.classes.input,
      'formkit-inner flex w-full flex-wrap items-center gap-2 rounded border border-neutral-400 bg-white px-3 py-2 text-base shadow focus-within:!border-blue-500 focus-within:ring-1 focus-within:!ring-blue-500 group-[]/multistep:shadow-none group-[]/repeater:shadow-none group-data-[disabled]:!cursor-not-allowed group-data-[invalid]:border-red-500 group-data-[disabled]:bg-neutral-100 group-data-[invalid]:ring-1 group-data-[invalid]:ring-red-500 dark:border-neutral-500 dark:bg-transparent dark:group-data-[invalid]:border-red-500 dark:group-data-[disabled]:bg-neutral-800/5 dark:group-data-[invalid]:ring-red-500',
    ]"
  >
    <TagsInputItem
      v-for="item in tags"
      :key="item"
      :value="item"
      :disabled="isDisabled"
      class="flex items-center justify-center gap-x-2 rounded bg-primary px-0.5 aria-[current=true]:bg-primary/60"
    >
      <TagsInputItemText class="pl-1 text-sm" />
      <TagsInputItemDelete
        :disabled="isDisabled"
        class="rounded bg-transparent p-0.5 hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-50"
      >
        ×
      </TagsInputItemDelete>
    </TagsInputItem>

    <TagsInputInput
      :placeholder="context.attrs.placeholder || 'Type and press Enter'"
      :disabled="isDisabled"
      :aria-required="isRequired"
      :aria-invalid="hasErrors"
      :class="[
        'formkit-input min-h-[1.5em] min-w-0 grow appearance-none border-none bg-transparent p-0 text-base text-neutral-700 outline-none [color-scheme:light] selection:bg-blue-100 selection:text-neutral-700 placeholder:text-neutral-400 focus:ring-0 group-data-[disabled]:!cursor-not-allowed group-data-[has-overlay]:selection:!text-transparent dark:text-neutral-300 dark:placeholder-neutral-400/50 dark:[color-scheme:dark]',
      ]"
    />
  </TagsInputRoot>
</template>

<script setup lang="ts">
import { TagsInputInput, TagsInputItem, TagsInputItemDelete, TagsInputItemText, TagsInputRoot } from "reka-ui";
import { computed } from "vue";

const props = defineProps({
  context: {
    type: Object,
    required: true,
  },
});

const tags = computed(() => props.context.value || []);
const isDisabled = computed(() => props.context.disabled || props.context.attrs.disabled);
const isRequired = computed(() => props.context.state.required);
const hasErrors = computed(() => props.context.state.valid === false);

const updateTags = (newTags) => {
  props.context.node.input(newTags);
};
</script>
